export default function UserFlow() {
  return (
    <section className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full text-teal-700 text-sm font-semibold mb-4">
            <i className="ri-route-line"></i>
            <span>So funktioniert's</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            In 4 einfachen Schritten<br />
            zu mehr Business Partnern
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Von der Lead-Generierung bis zum erfolgreichen Abschluss
          </p>
        </div>

        {/* Flow Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Step 1 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8 h-full">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center text-white text-xl font-bold mb-6">
                1
              </div>
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-search-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Leads finden
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Starte eine automatische Lead-Suche in deiner Region. Filtere gezielt nach 
                Heilberufen ohne bestehende NEM-Produkte für maximales Potenzial.
              </p>
            </div>
            {/* Arrow */}
            <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-teal-300 text-3xl"></i>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 h-full">
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center text-white text-xl font-bold mb-6">
                2
              </div>
              <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-database-2-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Im CRM verwalten
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Alle gefundenen Leads werden automatisch im CRM erfasst. Sieh dir die 
                NEM-Portfolio-Analyse an und verschiebe Leads durch deine Pipeline.
              </p>
            </div>
            {/* Arrow */}
            <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-blue-300 text-3xl"></i>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 h-full">
              <div className="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center text-white text-xl font-bold mb-6">
                3
              </div>
              <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-mail-send-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Kontakt aufnehmen
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Nutze KI-generierte E-Mail-Vorlagen für die erste Kontaktaufnahme. 
                Personalisiert, professionell und auf den Lead zugeschnitten.
              </p>
            </div>
            {/* Arrow */}
            <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
              <i className="ri-arrow-right-line text-purple-300 text-3xl"></i>
            </div>
          </div>

          {/* Step 4 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 h-full">
              <div className="w-12 h-12 bg-orange-600 rounded-xl flex items-center justify-center text-white text-xl font-bold mb-6">
                4
              </div>
              <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-share-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Funnel teilen
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Teile deinen personalisierten Funnel-Link auf Social Media. Interessenten 
                durchlaufen den Quiz und werden automatisch als Leads erfasst.
              </p>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl border border-teal-200">
            <i className="ri-time-line text-teal-600 text-2xl"></i>
            <div className="text-left">
              <div className="font-semibold text-gray-900">Spare bis zu 20 Stunden pro Woche</div>
              <div className="text-sm text-gray-600">Automatisierte Prozesse für maximale Effizienz</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
